module.exports = __webpack_public_path__ + "img/img-default-reload.6b60b52d.svg";